import React from 'react';

const SLKS = React.lazy(() => import('./SLKS'))

export const slksConfigs = [
  {
    path: '/slks/dashboard',
    element: <SLKS />,
    permittedRole: ['Operator', 'Operator Eselon 1']
  },
  {
    path: '/slks/proyeksi',
    element: <SLKS />,
    permittedRole: ['Operator', 'Operator Eselon 1']
  },
  {
    path: '/slks/verifikasi',
    element: <SLKS />,
    permittedRole: ['Operator', 'Operator Eselon 1']
  },
  {
    path: '/slks/approval',
    element: <SLKS />,
    permittedRole: ['Operator', 'Operator Eselon 1']
  },
  {
    path: '/slks/pengiriman',
    element: <SLKS />,
    permittedRole: ['Operator', 'Operator Eselon 1']
  },
  {
    path: '/slks/periode',
    element: <SLKS />,
    permittedRole: ['Operator', 'Operator Eselon 1']
  },
  {
    path: '/slks/salinan-keppres',
    element: <SLKS />,
    permittedRole: ['Operator', 'Operator Eselon 1']
  },
];
